// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".companies-table {\n  background-color: white;\n}\n.companies-table .ant-table-pagination {\n  margin: 1rem;\n}\n.companies-table th.ant-table-cell.ant-table-selection-column .ant-table-selection {\n  display: none;\n}\n.data-export-clmn {\n  display: grid;\n  justify-items: end;\n  margin: 20px 0;\n}\n", ""]);
// Exports
module.exports = exports;
